import Layout from "../components/layout";

function AboutView() {
    return (
        <Layout>
            <div className="card">
                <div className="card-body">
                    <h3 className="card-title">Über Joshirando</h3>
                    <div className="card-body">
                        <h4>Entstehung von Joshirando</h4>
                        <p>
                            Eigentlich hat das ganze wie so vieles mit Corona seinen lauf genommen. (Für spätere Leser,
                            das war diese Pandemie um 2020 herum). Zu dieser Zeit hat sich die IT-Abteilung in zwei
                            Lager aufgespalten. Zum einen gab es die Homeoffice-ler und zum anderen die “vor Ort” IT.
                            Hatte natürlich nichts mit der bisherigen “dunkle Seite”, “helle Seite” Aufteilung zu tun
                            gehabt, die passenderweise die Lager gut absteckt. Das Ganze hatte den praktischen
                            Hintergrund, dass ein Teil ausfallen konnte und der andere parat stand um weiterzumachen.
                            Dennoch gibt es auch physische Gegenstände wie das Diensthandy oder der wichtigste
                            Abteilungsbestandteil $Kuchen, welche zwischen den beiden Lagern ausgetauscht werden
                            mussten. Diesen “Lieferdienst” übernahm oftmals unser Dauerauzubildender Joshua aka Joshi!
                            So kam schnell der Name <b>Joshirando</b> ins Spiel.
                        </p>
                        <br/>

                        <h4>Die Bestellplattform</h4>
                        <p>Während dieser ominösen Pandemiezeit nahmen auch die im Unternehmen durchgeführten
                            Essensbestellungen zu. In der IT wurden diese natürlich von Joshi durchgeführt, aber auch
                            andere Abteilungen waren fleißig am Bestellen. Und da kam das Problem auf. Trotz der
                            bisherigen Bemühungen mit dem <b>Hungergames-Channels</b> im firmenweiten Chatsystem,
                            blieben Bestellungen oft abteilungsintern und andere bekamen nichts davon mit. Diesem
                            Missstand mussten wir natürlich beikommen und den Namen hatten wir zu dem Zeitpunkt ja schon
                        </p>
                        <br/>

                        <h4>Joshirando.de</h4>
                        <p>Diese Seite ist natürlich auf meinem Mist gewachsen. (👋 Hey, wer es nicht weiß hier ist
                            Jani) Ich hab mich in meiner Freizeit hingesetzt und die Ideenküche brodeln lassen. Und nach
                            ein paar Stunden programmieren und dem ein oder anderen zerstampften Bug kam die jetzige
                            Plattform dabei raus. Natürlich ist sie nicht fertig und auch durch das gute KVP wurden
                            schon einige kleine Verbesserungen eingestreut, aber ich tue mein bestes die Plattform
                            kontinuierlich zu verbessern. Dafür nehme ich auch gerne Feedback entgegen. Das ganze läuft
                            auf meinen privaten Servern und kann nur aus dem ene’t Netz erreicht werden.</p>
                        <br/>

                        <h4>Datenschutz und Nutzung</h4>
                        <p>Eure Daten sind natürlich sicher bei mir :D. Nein Spaß bei Seite. Ich erlaube mir eure
                            E-Mail-Adresse zur Identifizierung während des Loginverfahrens zu verwenden. Diese wird
                            dementsprechend auch gespeichert. Wenn ihr also eure E-Mail-Adresse angebt (egal ob privat
                            oder ene’t spezifisch), wird diese in meiner Datenbank gespeichert. Ich werde diese Adressen
                            aber natürlich nur zum Zusenden des MLT (Magic Login Token) und für Eigenwerbung verwenden.
                            Wer allerdings seine eingetragene E-Mail-Adresse ändern oder löschen möchte, kann mich jeder
                            Zeit dazu kontaktieren.</p>
                        <br/>

                        <h4>Impressum </h4>
                        <p>
                            Jan-Niklas (Jani) Niebel<br/>
                            Büro 2.10 - der erste Platz links
                        </p>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default AboutView